// extracted by mini-css-extract-plugin
module.exports = {"WelcomeText":"WelcomeText_WelcomeText__WvYiv"};